import { render, staticRenderFns } from "./news_article.vue?vue&type=template&id=f0fc0530&"
import script from "./news_article.vue?vue&type=script&lang=js&"
export * from "./news_article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports